export const assignColorToUser = (
    myUserId: string,
    userId: string,
    userColor: string | undefined,
    availableColors: string[],
    usedColors: string[],
    colorMap: Record<string, string>
): string => {
    // Si l'utilisateur a déjà une couleur assignée, on la retourne
    if (colorMap[userId]) {
        return colorMap[userId];
    }

    // Si l'utilisateur a une couleur définie, on l'utilise
    if (userId === myUserId && userColor) {
        return userColor;
    }

    // On cherche une couleur disponible qui n'est pas déjà utilisée
    const remainingColors = availableColors.filter(color => !usedColors.includes(color));
    if (remainingColors.length > 0) {
        return remainingColors[0];
    }

    // Si toutes les couleurs sont utilisées, on réutilise une couleur de manière cyclique
    return availableColors[Object.keys(colorMap).length % availableColors.length];
};